import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, Home, CalendarCheck } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { trackFunnelStep } from '../../utils/analytics';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Optionally parse query params from Doku to get invoice/booking code if provided
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('order_id') || queryParams.get('invoice_number');
    
    trackFunnelStep('payment_success', { booking_code: orderId });
  }, [location.search]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 bg-gray-50/50">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border p-8 text-center animate-in fade-in zoom-in duration-500">
        <div className="w-20 h-20 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10" />
        </div>
        
        <h1 className="text-2xl font-display font-semibold text-gray-900 mb-2">
          Status Reservasi
        </h1>
        
        <p className="text-gray-600 mb-8 text-sm">
          Terima kasih telah melakukan reservasi. Jika Anda telah menyelesaikan pembayaran, sistem kami akan mengonfirmasinya secara otomatis dalam beberapa menit. <br/><br/>
          <i>Jika Anda belum membayar atau membatalkan proses pembayaran, Anda tetap bisa melanjutkannya melalui link yang telah kami kirimkan ke email Anda.</i>
        </p>

        <div className="flex flex-col gap-3">
          <Button 
            onClick={() => navigate('/check-reservation')}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white h-12 text-base"
          >
            <CalendarCheck className="w-4 h-4 mr-2" />
            Cek Status Reservasi
          </Button>
          
          <Button 
            variant="outline" 
            onClick={() => navigate('/')}
            className="w-full h-12 text-base"
          >
            <Home className="w-4 h-4 mr-2" />
            Kembali ke Beranda
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
